import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { Toaster } from "@/components/ui/sonner";
import Branding from "@/pages/Branding";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CRM from "@/pages/CRM";
import ContactDetail from "@/pages/ContactDetail";
import Receptionist from "@/pages/Receptionist";
import DesignTool from "@/pages/DesignTool";
import Estimating from "@/pages/Estimating";
import PriceBook from "@/pages/PriceBook";
import Proposals from "@/pages/Proposals";
import PublicProposal from "@/pages/PublicProposal";
import Production from "@/pages/Production";
import JobDetail from "@/pages/JobDetail";
import QuickBooks from "@/pages/QuickBooks";
import CashFlow from "@/pages/CashFlow";
import AIManager from "@/pages/AIManager";
import HailTrace from "@/pages/HailTrace";
import Team from "@/pages/Team";
import StyleGuide from "@/pages/StyleGuide";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Scheduling from "@/pages/Scheduling";
import Invoices from "@/pages/Invoices";
import Reviews from "@/pages/Reviews";
import Analytics from "@/pages/Analytics";
import PublicInstaQuote from "@/pages/PublicInstaQuote";
import QuoteWidget from "@/pages/QuoteWidget";
import ScopeTemplates from "@/pages/ScopeTemplates";

function Protected({ children }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready || user === null)
    return <div className="min-h-screen flex items-center justify-center bg-cloud text-navy font-display text-xl">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return children;
}

function OwnerRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null)
    return <div className="min-h-screen flex items-center justify-center bg-cloud text-navy font-display text-xl">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "owner") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrandingProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/proposal/:id" element={<PublicProposal />} />
            <Route path="/quote" element={<PublicInstaQuote />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/crm" element={<CRM />} />
              <Route path="/crm/contact/:id" element={<ContactDetail />} />
              <Route path="/receptionist" element={<Receptionist />} />
              <Route path="/design" element={<DesignTool />} />
              <Route path="/estimating" element={<Estimating />} />
              <Route path="/scheduling" element={<Scheduling />} />
              <Route path="/pricebook" element={<PriceBook />} />
              <Route path="/scope-templates" element={<ScopeTemplates />} />
              <Route path="/proposals" element={<Proposals />} />
              <Route path="/production" element={<Production />} />
              <Route path="/production/job/:id" element={<JobDetail />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/quickbooks" element={<QuickBooks />} />
              <Route path="/cashflow" element={<CashFlow />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/quote-widget" element={<QuoteWidget />} />
              <Route path="/ai" element={<AIManager />} />
              <Route path="/hailtrace" element={<HailTrace />} />
              <Route path="/team" element={<OwnerRoute><Team /></OwnerRoute>} />
              <Route path="/branding" element={<OwnerRoute><Branding /></OwnerRoute>} />
              <Route path="/style-guide" element={<StyleGuide />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </BrandingProvider>
    </div>
  );
}

export default App;
